import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';

@Component({
    selector: 'app-toast',
    templateUrl: './toast.component.html',
    styleUrls: ['./toast.component.scss']
})

export class ToastComponent implements OnInit {
  @Input() message: string;
  @Input() buttonText: string[];

  @Output() actionCallback = new EventEmitter();
  @Output() dismissCallback = new EventEmitter();

  private dismissTimer: any;

  ngOnInit() {
    this.dismissTimer = setTimeout(() => {
      this.dismissCallback.emit();
    }, 6000);
  }

  onActionClick(action: string): void {
    this.actionCallback.emit(action);
    clearTimeout(this.dismissTimer);
    this.dismissCallback.emit();
  }

  onCloseClick(): void {
    clearTimeout(this.dismissTimer);
    this.dismissCallback.emit();
  }
}
